import { useTranslation } from 'react-i18next';
import TitleBar from '../utils/TitleBar.js';

function DryContact(props) {
    const { t } = useTranslation();
    const { data } = props;

    let ValueNumber = "-";
    let ValueAlarmLevel = "-";
    let TempDetector = "-";
    let SmokeDetector = "-";
    let SpaceDetector = "-";
    let AlarmSwitch = "-";
    let MessageCounter = "-";
    let FaultLevel = "-";
    let FaultCode = "-";
    if (data && data.Data) {
        let xdata = data.Data.map((v) => v.toString(16).padStart(2,"0")).join("");
        if(xdata){
            if(xdata.length < 16) { //小于16个字符则补足16个
                xdata = xdata.padEnd(16, '0');
            } else if(xdata.length > 16) {  //大于16个字符则取前16个
                xdata = xdata.slice(0, 16);
            }
            //将长度为16的hex字符串转换为64bit的串
            const bits = xdata.split('').map(v => Number('0x' + v).toString(2).padStart(4, '0')).join('')  
            //将64bit的串按字节分割为数组
            const bytes = bits.match(/(.{8})/g);
            //对bytes的每个字节进行处理
            const vs = bytes.map(v => parseInt(v, 2))
            ValueNumber = vs[0]
            ValueAlarmLevel = vs[1]
            TempDetector = vs[2] == 0 ? t('Normal') : vs[2] == 1 ? t('Alarm') : t('Unknown')
            SmokeDetector = vs[3] == 0 ? t('Normal') : vs[3] == 1 ? t('Alarm') : t('Unknown')
            SpaceDetector = vs[4]
            AlarmSwitch = vs[5] == 0 ? t('Alarm-Switch-Up') : vs[5] == 1 ? t('Alarm-Switch-Down') : t('Unknown')
            MessageCounter = vs[6]
            const v8 = bytes[7]  //第8个字节单独处理
            const v8_1 = v8.slice(0, 2)
            const v8_2 = v8.slice(2, 8)
            const levelValue = parseInt(v8_1, 2)
            FaultLevel = levelValue == 0 ? t('None') : levelValue == 1 ? t('Level 1') : levelValue === 2 ? t('Level 2') : t('Unknown')
            FaultCode = parseInt(v8_2, 2)
            
        }
    }

    return (
        <div style={{padding: '10px 15px'}}>
            <TitleBar title={t('Dry-Contact')} data={data} />
            <div style={{marginTop: '20px'}}>
                <div style={{backgroundColor: '#f0f0f0', width: '100%',height: '270px', borderRadius: '10px',  padding: '4px 4px'}}>
                    <div>
                        <div style={{fontSize: '9px'}}>{t('Value Number')}: {ValueNumber}</div>
                        <div style={{fontSize: '9px'}}>{t('Value Alarm Level')}: {ValueAlarmLevel}</div>
                        <div style={{fontSize: '9px'}}>{t('Temperature Detector')}: {TempDetector}</div>
                        <div style={{fontSize: '9px'}}>{t('Smoke Detector')}: {SmokeDetector}</div>
                        <div style={{fontSize: '9px'}}>{t('Space Detector')}: {SpaceDetector}</div>
                        <div style={{fontSize: '9px'}}>{t('Alarm Switch')}: {AlarmSwitch}</div>
                        <div style={{fontSize: '9px'}}>{t('Message Counter')}: {MessageCounter}</div>
                        <div style={{fontSize: '9px'}}>{t('Fault Level')}: {FaultLevel}</div>
                        <div style={{fontSize: '9px'}}>{t('Fault Code')}: {FaultCode}</div>

                    </div>
                </div>
            </div>
        </div>
    );
}

export default DryContact; 